export default {
  getGruposCaptura: state => state.gruposCaptura,
  getGrupoCapturaSelecionado: state => state.grupoCapturaSelecionado,
}
